module.exports = __webpack_public_path__ + "static/media/umbrella.8d4928da.svg";